import Map from '../components/map';

export default class ArchivesSingleMap {
    constructor(element) {
        this.headerWithMap = element
        this.map = this.headerWithMap.querySelector('.archive-list-header-with-map-map')
        this.locations = JSON.parse(this.headerWithMap.getAttribute('data-locations'))
        this.buttons = this.headerWithMap.querySelectorAll('.archive-list-header-with-map-control')

        for(const button of this.buttons) {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                this.handleControlClick()
            })
        }

        new Map(this.map, this.locations, null, null)
    }

    handleControlClick() {
        this.headerWithMap.classList.toggle('enlarge')
    }
}
